<template>
  <btn @click="onCopy" v-bind="$attrs">
    <slot></slot>
  </btn>
</template>

<script>
import Btn from './Button';
import Notify from '@groovepages/gd-lib/notify';
import ClipboardJS from 'clipboard';

export default {
  name: 'CopyBtn',
  components: { Btn },
  props: {
    clipText: {
      type: String,
      required: true
    },
    successMessage: {
      type: String,
      default: 'Copy successful'
    },
    failMessage: {
      type: String,
      default: 'Copy failed'
    }
  },
  data() {
    return {
      clipboard: undefined
    };
  },
  methods: {
    onCopy() {
      const el = document.createElement('button');
      const clipboard = new ClipboardJS(el, {
        text: () => this.clipText,
        action: () => 'copy',
        container: document.body
      });

      clipboard.on('success', () => {
        Notify.success(this.successMessage);
        clipboard.destroy();
      });
      clipboard.on('error', () => {
        Notify.fail(this.failMessage);
        clipboard.destroy();
      });

      el.click();
    }
  }
};
</script>
